import { useContext } from "react";
import { FunnelContext } from "./FunnelContext";

export function useFunnelForm() {
  const ctx = useContext(FunnelContext);
  if (!ctx) {
    throw new Error("useFunnelForm must be used inside <FunnelProvider>");
  }
  return ctx;
}
